//* ------------------------------------*\
//    $EVENTS
//* ------------------------------------*/

const EVENTS = {
  // ANIMATIONEND: 'animationend',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  // BEFOREUNLOAD: 'beforeunload',
  BLUR: 'blur',
  CAN_PLAY: 'canplay',
  CHANGE: 'change',
  CHANGE_DATE: 'changeDate',
  // CLEAR_FILTERS: 'clearfilters',
  CLICK: 'click',
  COLLAPSE_ACCORDION: 'collapseaccordion',
  // CUSTOM_EVENT: 'customevent',
  // DISPLAY_SUBHEADING: 'displaysubheading',
  // DROPDOWN_CHANGED: 'dropdownchanged',
  DOM_CONTENT_LOADED: 'DOMContentLoaded',
  ENTER: 'Enter',
  FILTER_FORM_SUBMIT: 'filterFormSubmit',
  // FORM_ERROR: 'formerror',
  // FORM_SUCCESS: 'formsuccess',
  FOCUS: 'focus',
  FORM_SUBMIT: 'formsubmit',
  // HEADER_HIDING: 'header-hiding',
  INPUT: 'input',
  INVALID: 'invalid',
  KEY_DOWN: 'keydown',
  KEY_PRESS: 'keypress',
  LOADED_METADATA: 'loadedmetadata',
  MOUSEDOWN: 'mousedown',
  MOUSEENTER: 'mouseenter',
  MOUSELEAVE: 'mouseleave',
  // MOUSEMOVE: 'mousemove',
  MOUSEOUT: 'mouseout',
  MOUSEOVER: 'mouseover',
  // PAGESHOW: 'pageshow',
  POP_STATE: 'popstate',
  PAUSE_VIDEO: 'pausevideo',
  POINTER_DOWN: 'pointerdown',
  PUSH_STATE: 'pushstate',
  READY: 'ready',
  // REQUEST_MADE: 'requestmade',
  RESIZE: 'resize',
  // RESULTS_RETURNED: 'resultsreturnd',
  SCROLL: 'scroll',
  // SIMULATED_CLICK: 'simulated-click',
  // SHOW_HIDE: 'showhide',
  SUBMIT: 'submit',
  TOUCH_CAN: 'touchcancdocument',
  TOUCH_END: 'touchend',
  TOUCH_MOVE: 'touchmove',
  TOUCH_START: 'touchstart',
  TRANSITIONEND: 'transitionend',
  // UPDATE_POST_COUNT: 'updatepostcount',
  UPDATE_IN_VIEWPORT_MODULES: 'updateinviewportmodules',
  // UPDATE_SEARCH_WITH_NEW_ITEMS: 'updatesearchwithnewitems',
  // UPDATE_SETTINGS: 'updatesettings',
  WHEEL: 'wheel',
  MODAL_CLOSE: 'modalclose',
  MODAL_OPEN: 'modalopen'
};

export default EVENTS;
